const styles = {
  body: {
    backgroundColor: '#FAFAFA',
  },

}

export default styles
